"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { useUsersManagementState, } from "./users-management-state";
const UsersManagementContext = React.createContext(undefined);
UsersManagementContext.displayName = "UsersManagementContext";
const initialState = {
    pagination: null,
    role: null,
    searchQuery: null,
};
export const UsersManagementContextProvider = ({ children }) => {
    const [state, dispatch] = useUsersManagementState(initialState);
    const context = React.useMemo(() => ({
        state,
        dispatch,
    }), [state, dispatch]);
    return (_jsx(UsersManagementContext.Provider, { value: context, children: children }));
};
const NOOP = () => void 0;
const EMPTY_PAGINATION = {};
/**
 * The context may be provided if it is instantiated in the tree above the user.
 */
export function useUsersManagementContext(initialContext) {
    const context = React.useContext(UsersManagementContext);
    if (context) {
        return context;
    }
    if (initialContext) {
        return initialContext;
    }
    return {
        dispatch: NOOP,
        state: {
            pagination: EMPTY_PAGINATION,
            role: null,
            searchQuery: null,
        },
    };
}
//# sourceMappingURL=users-management-context.js.map